import { Badge } from 'antd'
import { IoIosNotifications } from 'react-icons/io'
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand } from 'react-icons/tb'
import { HiOutlineMenuAlt2 } from 'react-icons/hi'
import profile from '../../assets/icons/itachi.jpg'
import { useLocation, useNavigate } from 'react-router'
import { useGetProfileQuery } from '../../Redux/Apis/authApi'
import { url } from '../../Utils/BaseUrl'
import { useSocketContext } from '../../Context/SocketContext'
import { SidebarGroups, SidebarLink } from '../../Utils/Sideber/SidebarLink'

/* Route → page title, built once from the sidebar catalog plus a few routes
   that have no sidebar entry. The current page title shows in the top bar. */
const ROUTE_TITLES = (() => {
    const map = { '/notification': 'Notifications' }
    SidebarLink.forEach((l) => { map[l.path] = l.label })
    SidebarGroups.forEach((g) => g.links.forEach((l) => { map[l.path] = l.label }))
    return map
})()

const Header = ({ collapsed, isMobile, onToggle }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const { data } = useGetProfileQuery()
    const { notifications } = useSocketContext();
    const unreadNotifications = notifications?.filter((notification) => notification?.isRead === false);
    const pageTitle = ROUTE_TITLES[location.pathname] || ''
    return (
        <div className='bg-[var(--primary-bg)] flex items-center justify-between h-[72px] px-3 md:px-4'>
            <div className='flex items-center gap-2 md:gap-3 min-w-0'>
                <button
                    onClick={onToggle}
                    className='p-2 rounded-lg text-[var(--bg-white)] hover:bg-[var(--bg-white)]/10 transition-colors shrink-0'
                    title={isMobile ? 'Menu' : collapsed ? 'Expand' : 'Collapse'}
                >
                    {isMobile
                        ? <HiOutlineMenuAlt2 size={24} />
                        : collapsed ? <TbLayoutSidebarLeftExpand size={24} /> : <TbLayoutSidebarLeftCollapse size={24} />}
                </button>
                <p className='text-lg md:text-xl font-semibold text-[var(--bg-white)] truncate'>{pageTitle}</p>
            </div>
            <div className='end-center gap-3 md:gap-6'>
                <Badge onClick={() => navigate('/notification')} className='bg-[var(--bg-white)] rounded-full cursor-pointer' count={unreadNotifications.length || 0}>
                    <IoIosNotifications size={40} />
                </Badge>
                <div onClick={() => navigate('/profile')} className='center-center gap-2 px-3 w-fit py-1 border border-[var(--bg-white)] rounded-md cursor-pointer'>
                    <img className='w-9 h-9 md:w-10 md:h-10 rounded-full object-cover' src={data?.data?.img ? `${url}/${data?.data?.img}` : profile} alt={data?.data?.name || 'Profile'} />
                    <p className='text-base text-[var(--color-white)] hidden sm:block'>{data?.data?.name}</p>
                </div>
            </div>
        </div>
    )
}

export default Header
